import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import axios from "./../helpers/axios";
import Routes from "./routes/Routes";
import { ENDPOINT_CURRENT_USER } from "./endpoints";

export default function IsAuth() {
  const [data, setData] = useState();
  const { token } = useSelector(state => ({
    ...state.User
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    const response = localStorage.getItem("token");

    if (response) {
      axios.get(ENDPOINT_CURRENT_USER).then(({ data }) => {
        if (data) {
          setData(data);
          dispatch({
            type: "CURRENT_USER",
            payload: {
              token: response,
              username: data.username,
              userImg: data.urlImg,
              name: data.name,
              posts: data.posts,
              userId: data._id
            }
          });
        }
      });
    }
  }, [dispatch, token]);

  return <Routes isAuth={data ? token : null} />;
}
